import React, { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { Box, Divider, FormControl, Grid, Tooltip, Typography } from "@mui/material";

// Components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/NewDesign/PageTitle";
import CustomButton from "examples/NewDesign/CustomButton";
import BasicButton from "examples/NewDesign/CustomButton/BasicButton";
import pxToRem from "assets/theme/functions/pxToRem";
import FullScreenImageComponent from "components/ViewFullImage/ViewImage";
import EquipmentDetailDrawer from "examples/Drawers/Equiupment/EquipmentDetail";
import FilterDropdown from "components/Dropdown/FilterDropdown";
import MultiSelectDropdown from "components/Dropdown/MultiSelectDropdown";
import BasicModal from "examples/modal/BasicModal/BasicModal2";
import ResetFilterButton from "components/Buttons/ResetButton";
import ExplicitSearchBar from "components/Search/ExplicitSearchBar";
import Status from "components/Table/Status";

// Data
import DataTable from "examples/Tables/DataTable";
import InvenotryDataTable from "examples/Tables/DataTable/InventoryTableWithLazyLoading";
import ProductData from "layouts/resources/data/productData";
import StockUpdateData from "layouts/resources/data/stockUpdateData";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { openSnackbar } from "redux/Slice/Notification";
import {
  InventoryListV2Thunk,
  equipmentStockUpdateThunk,
  exportInventoryExcelDataV2,
  equipmentLocationV2Thunk,
  typeConvertThunk,
} from "redux/Thunks/Equipment";
import { projectListThunk } from "redux/Thunks/Filter";
import configThunk, { equipmentConfig } from "redux/Thunks/Config";
import {
  reloadData,
  resetListState,
  updateStockCheckbox,
  updateQuantity,
  deleteStock,
} from "redux/Slice/Equipment";
import { useLocation, useNavigate } from "react-router-dom";

// Constants
import Constants, {
  Icons,
  Colors,
  ModalContent,
  PageTitles,
  defaultData,
  ButtonTitles,
  Common,
  FiltersModuleName,
} from "utils/Constants";

import { paramCreater } from "utils/methods/methods";
import CustomDrawer from "components/Drawer/CustomDrawer";
import CustomAutoComplete from "components/Dropdown/CustomAutoComeplete";
import InventoryRegister from "./InventoryRegisterForm/InventoryRegister";
import { darkTooltipProps, buildQuantityLines } from "./locationTooltip";

const initialLocation = {
  loading: false,
  open: false,
  equipmentName: "",
  quantity: 0,
  totalQuantity: 0,
  id: "",
  data: [],
  projectData: [],
};

// `Status` keys its palette on the spaced wording ("check in", not "check-in"), the same
// conversion the order detail header does before handing a status to it.
const toStatusTitle = (status) => String(status ?? "").replace("-", " ");

const initialEquipmentLocation = {
  warehouseListing: [],
  projectListing: [],
};

function ProductDetails() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const ConfigData = useSelector((state) => state.config);
  const warehouseInfoFields = ConfigData?.equipmentConfig?.properties?.warehouseInfo || [];
  const permission = ConfigData?.screens?.[8]?.screensInfo?.agreement;
  const productList = useSelector((state) => state.product);
  const stockData = useSelector((state) => state.product);
  const [tablePagination, setTablePagination] = useState({
    page: defaultData.PAGE,
    perPage: defaultData.PER_PAGE_6,
  });

  const [filters, setFilters] = useState([
    {
      inputLabel: FiltersModuleName.MISSING,
      list: [
        { [Constants.MONGOOSE_ID]: "all", title: "All" },
        { [Constants.MONGOOSE_ID]: "qr", title: "QR" },
        { [Constants.MONGOOSE_ID]: "certificate", title: "Certificate" },
        { [Constants.MONGOOSE_ID]: "certificate_expired", title: "Certificate Expired" },
        {
          [Constants.MONGOOSE_ID]: "certificate_expire_in_30",
          title: "Certificate Expiring in 30 days",
        },
        {
          [Constants.MONGOOSE_ID]: "certificate_expire_in_60",
          title: "Certificate Expiring in 60 days",
        },
      ],
      selectedValue: "all",
    },
    {
      inputLabel: FiltersModuleName.CONDITION,
      list: [
        { [Constants.MONGOOSE_ID]: "ok", title: "OK" },
        { [Constants.MONGOOSE_ID]: "quarantine", title: "Quarantine" },
        { [Constants.MONGOOSE_ID]: "write-off", title: "Write Off" },
      ],
      selectedValue: ["ok", "quarantine"],
    },
    // One box covering name, category and type — the backend ORs across all three.
    {
      inputLabel: Common.INVENTORY_SEARCH,
      list: [{ [Constants.MONGOOSE_ID]: "all", title: "All" }],
      selectedValue: "all",
      isLoading: false,
    },
    {
      inputLabel: "Product Number",
      list: [{ [Constants.MONGOOSE_ID]: "all", title: "All" }],
      selectedValue: "all",
      isLoading: false,
    },
    {
      inputLabel: "Serial number",
      list: [{ [Constants.MONGOOSE_ID]: "all", title: "All" }],
      selectedValue: "all",
      isLoading: false,
    },
    {
      inputLabel: Common.LOCATION_INVENTORY,
      list: [{ [Constants.MONGOOSE_ID]: "all", title: "All" }],
      selectedValue: "all",
      isLoading: false,
    },
  ]);
  const [locationFilter, setLocationFilter] = useState(initialEquipmentLocation);
  const [stockShow, setStockShow] = useState(false);
  const [openStockEditModal, setOpenStockEditModal] = useState(false);
  const [openInventoryModal, setOpenInventoryModal] = useState({ right: false });
  const [exportLoading, setExportLoading] = useState(false);
  const [shouldUpdateState, setShouldUpdateState] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [equipmentId, setEquipmentId] = useState("");
  const [equipmentLocation, setEquipmentLocation] = useState(initialLocation);
  const [openPermanentType, setOpenPermanentType] = useState({
    open: false,
    loading: false,
    data: {},
    newType: "",
    oldType: "",
  });
  const [equipmentOptionsList, setEquipmentOptionsList] = useState([]);
  const [fullScreenImage, setFullScreenImage] = useState(null);
  // use for handling equipment drawer
  const [equipmentAnchor, setEquipmentAnchor] = useState({ right: false });
  const [equipmentDrawerId, setEquipmentDrawerId] = useState("");
  // Common Function to Create Params for get Product API
  const createParamData = (filter, pagination = {}) => {
    const filterMapping = [
      { key: "missing", value: filter[0]?.selectedValue },
      {
        key: "condition",
        value: filter[1]?.selectedValue?.length > 0 ? filter[1]?.selectedValue?.join(",") : "",
      },
      { key: "search", value: filter[2]?.selectedValue },
      { key: "equipmentNumber", value: filter[3]?.selectedValue },
      { key: "serialNumber", value: filter[4]?.selectedValue },
      { key: Common.LOCATION_KEY, value: filter[5]?.selectedValue },
    ];

    return filterMapping.reduce(
      (acc, { key, value }) => {
        if (
          value &&
          typeof value === "string" &&
          value?.trim() !== "" &&
          value.toLowerCase() !== "select" &&
          value?.toLowerCase() !== "all"
        ) {
          // Handle location filter logic
          if (key === Common.LOCATION_KEY) {
            const selectedLocation = filter[5]?.selectedValue;
            if (selectedLocation && selectedLocation !== "all") {
              // Check if it's a project or warehouse based on the locationFilter data
              const isProject = locationFilter.projectListing.some(
                (project) => project[Constants.MONGOOSE_ID] === selectedLocation
              );
              const isWarehouse = locationFilter.warehouseListing.some(
                (warehouse) => warehouse[Constants.MONGOOSE_ID] === selectedLocation
              );

              if (isProject) {
                return { ...acc, project: selectedLocation };
              }
              if (isWarehouse) {
                return { ...acc, warehouse: selectedLocation };
              }
            }
            return acc;
          }
          return { ...acc, [key]: value?.trim() };
        }
        return acc;
      },
      { ...pagination }
    );
  };

  const fetchProductList = async (filterValue = filters, paginationOverride) => {
    const nextPagination = paginationOverride || {
      page: defaultData.PAGE,
      perPage: tablePagination.perPage,
    };

    setTablePagination((prev) => ({ ...prev, ...nextPagination }));

    const paramData = createParamData(filterValue, nextPagination);
    await dispatch(InventoryListV2Thunk(paramCreater(paramData)));
  };

  const getEquipmentConfigFunc = async () => {
    await dispatch(equipmentConfig());
  };

  // function to get equipment locations
  const getEquipmentLocationFunc = async () => {
    if (locationFilter.projectListing.length > 0 || locationFilter.warehouseListing.length > 0) {
      return;
    }

    try {
      const projectRes = await dispatch(projectListThunk());
      const warehouseRes = warehouseInfoFields?.find((item) => item.id === "warehouse")?.options;

      // Check if we have the required data
      if (!projectRes?.payload?.data || !warehouseInfoFields || warehouseInfoFields.length === 0) {
        return;
      }

      const projectList = projectRes.payload.data.map((item) => ({
        [Constants.MONGOOSE_ID]: item[Constants.MONGOOSE_ID],
        title: `(P) ${item.title}`,
      }));

      const warehouseResModified =
        warehouseRes?.map((item) => ({
          [Constants.MONGOOSE_ID]: item.id,
          title: `(W) ${item.title}`,
        })) || [];

      setLocationFilter({
        warehouseListing: warehouseResModified || [],
        projectListing: projectList || [],
      });

      // Update the Location filter list with the fetched data
      setFilters((prev) =>
        prev.map((filter) =>
          filter.inputLabel === Common.LOCATION_INVENTORY
            ? {
                ...filter,
                list: [
                  { [Constants.MONGOOSE_ID]: "all", title: "All" },
                  ...(warehouseResModified || []),
                  ...(projectList || []),
                ],
              }
            : filter
        )
      );
    } catch (error) {
      console.error("Error in getEquipmentLocationFunc:", error);
    }
  };

  const handleImageFullView = (imageUrl) => {
    setFullScreenImage(imageUrl);
  };
  const handleCloseFullView = () => {
    setFullScreenImage(null);
  };

  // open Equipment drawer from rigth
  const handleOpenEquipmentDetailDrawer = async (id) => {
    setEquipmentAnchor({ right: true });
    setEquipmentDrawerId(id);
  };

  const handleCloseEquipmentDetailDrawer = async (id) => {
    setEquipmentAnchor({ right: false });
    setEquipmentDrawerId(id);
  };

  // Open Inventory drawer
  const openInventoryRegisterModalFunc = (open) => {
    setOpenInventoryModal({ right: open });
  };

  const handleEditDrawerOpen = (item) => {
    setEquipmentId(item);
    setOpenInventoryModal({ right: true });
  };

  const handleInventoryDrawerClose = () => {
    setOpenInventoryModal({ right: false });
    setEquipmentId("");
  };

  const handleStockUpdateCheckboxChange = async (element, checked) => {
    const elemObj = {
      ...element,
      stockQuantity: 0,
      totalStock: Number(element.quantity) || 0,
    };
    await dispatch(updateStockCheckbox({ equipmentData: elemObj, checked }));
  };

  const handleStockChange = async (e, Id, name) => {
    const { value = 0 } = e.target;
    const updatedStockValue =
      name === "validateStockQuantity" && value === "" ? 0 : parseInt(value, 10) || 0;

    await dispatch(updateQuantity({ stockQuantity: updatedStockValue, equipmentId: Id }));
  };

  const handleUpdateStock = async () => {
    const isValid = !stockData.stockData.some(
      (item) => item.stockQuantity === 0 || item.totalStock < 0
    );
    if (isValid) {
      const body = stockData.stockData.map((item) => ({
        equipment: item[Constants.MONGOOSE_ID],
        quantity: item?.totalStock,
      }));

      setButtonLoading(true);
      setDisableSubmit(true);

      const res = await dispatch(equipmentStockUpdateThunk(body));
      setDisableSubmit(false);
      if (res.payload.status === 200) {
        setOpenStockEditModal(false);
        setStockShow(false);
        setButtonLoading(false);
        await dispatch(resetListState());
        await fetchProductList();
        await dispatch(
          openSnackbar({
            message: Constants.STOCKS_UPDATE_SUCCESS,
            notificationType: Constants.NOTIFICATION_SUCCESS,
          })
        );
      } else {
        await dispatch(
          openSnackbar({
            message: Constants.SOMETHING_WENT_WRONG,
            notificationType: Constants.NOTIFICATION_ERROR,
          })
        );
      }
    } else {
      await dispatch(
        openSnackbar({
          message: Constants.INVALID_VALUE,
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
    }
  };

  const handleDeleteStock = async (deleteId) => {
    await dispatch(deleteStock({ deleteId }));
  };

  // Stock out on an order is not in a warehouse, so the modal can show both kinds of line at
  // once. Only then do the two groups need naming.
  const showLocationSections =
    equipmentLocation?.data?.length > 0 && equipmentLocation?.projectData?.length > 0;

  // function to open equipment location modal
  const handleOpenEquipmentLocation = async (data) => {
    setEquipmentLocation({ open: true, loading: true });
    const res = await dispatch(equipmentLocationV2Thunk(data.id));
    setEquipmentLocation({ open: true, loading: false });
    if (res.payload.status === Common.API_STATUS_200) {
      setEquipmentLocation({
        open: true,
        equipmentName: data.name,
        quantity: data.quantity,
        totalQuantity: res?.payload?.data?.data?.totalQuantity,
        id: data.id,
        data: res?.payload?.data?.data?.data,
        projectData: res?.payload?.data?.data?.projectData ?? [],
      });
    } else {
      setEquipmentLocation(initialLocation);
      await dispatch(
        openSnackbar({
          message: Constants.SOMETHING_WENT_WRONG,
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
    }
  };

  useEffect(() => {
    const getEquipmentList = Array.isArray(ConfigData?.screens?.[8]?.screensInfo?.properties)
      ? ConfigData.screens[8].screensInfo.properties
      : [];

    const equipmentItem = getEquipmentList.find((item) => item.id === Common.EQUIPMENT_TYPE);
    const createDropdownListFunc = (listArr = []) => {
      const temp = listArr.map((item) => ({
        title: item.title,
        [Constants.MONGOOSE_ID]: item.id,
      }));

      return temp;
    };

    if (equipmentItem) {
      const withoutTempItems = equipmentItem.options.filter(
        (item) => item?.currency !== Common.TEMP_CURRENCY
      );
      const temp = createDropdownListFunc(withoutTempItems);
      setEquipmentOptionsList(temp);
    }
  }, [ConfigData]);

  const handleOpenPermanentType = async (data) => {
    setOpenPermanentType({
      open: true,
      loading: false,
      data,
      newType: "",
      equipmentId: data?.[Constants.MONGOOSE_ID],
      oldType: data?.equipmentType[Constants.MONGOOSE_ID],
    });
  };

  const handleTypeConversion = async () => {
    if (openPermanentType?.newType === "") {
      await dispatch(
        openSnackbar({
          message: Constants.TYPE_REQUIRED_ERROR,
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
      return;
    }
    const payload = {
      id: openPermanentType?.equipmentId,
      body: {
        oldEquipmentType: openPermanentType?.oldType,
        newEquipmentType: openPermanentType?.newType,
      },
    };
    setOpenPermanentType({ ...openPermanentType, loading: true });
    const res = await dispatch(typeConvertThunk(payload));
    setOpenPermanentType({ ...openPermanentType, loading: false });
    if (res.payload.status === Common.API_STATUS_200) {
      setOpenPermanentType({ open: false, loading: false, data: {} });
      await dispatch(reloadData());
      await fetchProductList();
      await dispatch(
        openSnackbar({
          message: Constants.TYPE_CONVERSION_SUCCESS,
          notificationType: Constants.NOTIFICATION_SUCCESS,
        })
      );
    } else if (res.payload.status === Common.API_STATUS_400) {
      setOpenPermanentType({ open: false, loading: false, data: {} });
      await dispatch(
        openSnackbar({
          message: res.payload.data.message,
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
    } else {
      await dispatch(
        openSnackbar({
          message: Constants.SOMETHING_WENT_WRONG,
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
    }
  };

  // Equipment Table data
  const { columns, rows } = ProductData({
    productList: productList.list,
    handleEditDrawerOpen,
    handleOpenEquipmentDetailDrawer,
    permissions: permission,
    stockShow,
    updateStockCheckboxFunc: handleStockUpdateCheckboxChange,
    stockData: stockData.stockData,
    handleOpenEquipmentLocation,
    handleOpenPermanentType,
  });

  const { stockColumns, stockRows } = StockUpdateData(
    stockData.stockData,
    handleStockChange,
    handleDeleteStock
  );

  const handleTablePagination = async (pageNumber) => {
    if (productList.pagination?.completed?.includes(pageNumber)) {
      setTablePagination((prev) => ({ ...prev, page: pageNumber }));
      return;
    }
    const pagination = { page: pageNumber, perPage: tablePagination.perPage };
    const paramData = createParamData(filters, pagination);
    const res = await dispatch(InventoryListV2Thunk(paramCreater(paramData)));
    if (res.payload.status === Common.API_STATUS_200) {
      setTablePagination((prev) => ({ ...prev, page: pageNumber }));
    }
  };

  const handleReload = async () => {
    await dispatch(reloadData());
    fetchProductList();
  };

  const handleFilterType = async (e) => {
    const { name, value } = e.target;
    if (value === "") return;

    // Handle autocomplete change for Location filter
    if (name === Common.LOCATION_INVENTORY) {
      const selectedOption = filters[5]?.list?.find((option) => option.title === value);
      if (selectedOption) {
        const newFilters = filters.map((filter) => {
          if (filter.inputLabel === Common.LOCATION_INVENTORY) {
            return {
              ...filter,
              selectedValue: selectedOption[Constants.MONGOOSE_ID],
            };
          }
          return filter;
        });
        setFilters(newFilters);
        await fetchProductList(newFilters);
        return;
      }
    }

    let newFilters;
    setFilters((prev) => {
      const updatedFilters = prev.map((filter) => {
        if (filter.inputLabel === name) {
          return {
            ...filter,
            selectedValue: value,
          };
        }
        return filter;
      });
      newFilters = updatedFilters;
      return updatedFilters;
    });

    await fetchProductList(newFilters);
  };

  const handleSearch = async (searchValue = filters, filterIndex) => {
    setFilters((prev) => {
      const temp = [...prev];
      temp[filterIndex].isLoading = true;
      return temp;
    });

    const pagination = { page: 0, perPage: tablePagination.perPage };
    const paramData = createParamData(searchValue, pagination);

    try {
      const res = await dispatch(InventoryListV2Thunk(paramCreater(paramData)));
      const temp = [...searchValue];

      let suggestions;
      const inventoryDataList = res?.payload?.data?.data?.inventoryData || [];
      const filterLabel = searchValue[filterIndex].inputLabel;
      switch (filterLabel) {
        // The merged box searches name, category and type, so it suggests from all three.
        case Common.INVENTORY_SEARCH:
          suggestions = inventoryDataList.flatMap((item) => [
            { [Constants.MONGOOSE_ID]: item[Constants.MONGOOSE_ID], title: item?.name },
            {
              [Constants.MONGOOSE_ID]: item[Constants.MONGOOSE_ID],
              title: item?.equipmentType?.type,
            },
            {
              [Constants.MONGOOSE_ID]: item[Constants.MONGOOSE_ID],
              title: item?.equipmentType?.equipmentCategory?.[0]?.name,
            },
          ]);
          break;
        case "Serial number":
          suggestions = inventoryDataList.map((item) => ({
            [Constants.MONGOOSE_ID]: item[Constants.MONGOOSE_ID],
            title: item?.serialNumber !== null ? item?.serialNumber : "",
          }));
          break;
        case "Product Number":
          suggestions = inventoryDataList.map((item) => ({
            [Constants.MONGOOSE_ID]: item[Constants.MONGOOSE_ID],
            title: item.equipmentNumber,
          }));
          break;
        default:
          suggestions = [];
      }

      const uniqueSuggestions = suggestions.reduce((acc, current) => {
        if (!current.title) return acc;
        const duplicate = acc.find((item) => item.title === current.title);
        if (!duplicate) {
          acc.push(current);
        }
        return acc;
      }, []);

      // Add the 'All' option and update the filter list
      temp[filterIndex].list = [
        { [Constants.MONGOOSE_ID]: "all", title: "All" },
        ...uniqueSuggestions,
      ];
      temp[filterIndex].isLoading = false;

      setFilters(temp);
    } catch (error) {
      setFilters((prev) => {
        const temp = [...prev];
        temp[filterIndex].isLoading = false;
        return temp;
      });
    }
  };

  const handleExplicitSearch = async (inputValue, filterIndex) => {
    // Determine the actual value to use for search
    const searchValue =
      inputValue === "" || inputValue === null || inputValue === undefined ? "all" : inputValue;

    // Update local filter state with the new input value
    const temp = [...filters];
    temp[filterIndex].selectedValue = searchValue;
    setFilters(temp);

    // Trigger search
    handleSearch(temp, filterIndex);
  };

  const handleReset = async () => {
    await dispatch(reloadData());
    const tempFilters = filters.map((filter) => {
      if (filter.inputLabel === FiltersModuleName.CONDITION) {
        return { ...filter, selectedValue: ["ok", "quarantine"] };
      }
      return { ...filter, selectedValue: "all" };
    });
    setFilters(tempFilters);
    await fetchProductList(tempFilters);
  };

  useEffect(() => {
    dispatch(configThunk());
    fetchProductList(filters);
  }, [shouldUpdateState]);

  useEffect(() => {
    getEquipmentConfigFunc();
    dispatch(resetListState());
  }, []);

  useEffect(() => {
    if (
      ConfigData?.equipmentConfig?.properties?.warehouseInfo &&
      ConfigData.equipmentConfig.properties.warehouseInfo.length > 0 &&
      locationFilter.projectListing.length === 0 // Only call if we haven't loaded the data yet
    ) {
      getEquipmentLocationFunc();
    }
  }, [ConfigData, locationFilter.projectListing.length]);

  // ---------------------------------------------------------------------------
  // URL PERSISTENCE LOGIC
  // ---------------------------------------------------------------------------

  // 1. Initialize filters from URL on mount
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const hasParams = [...params].length > 0;

    // Only initialize if there are params and NOT responding to specific navigation state (which overrides)
    if (hasParams && !location.state?.data) {
      const getVal = (key, defaultVal = "all") => params.get(key) || defaultVal;
      const getArrVal = (key, defaultVal = []) => {
        const val = params.get(key);
        return val ? val.split(",") : defaultVal;
      };

      const newFilters = [
        { ...filters[0], selectedValue: getVal("missing", "all") },
        { ...filters[1], selectedValue: getArrVal("condition", ["ok", "quarantine"]) },
        { ...filters[2], selectedValue: getVal("search", "all") },
        { ...filters[3], selectedValue: getVal("equipmentNumber", "all") },
        { ...filters[4], selectedValue: getVal("serialNumber", "all") },
        { ...filters[5], selectedValue: getVal(Common.LOCATION_KEY, "all") },
      ];

      setFilters(newFilters);

      const page = params.get("page");
      const perPage = params.get("perPage");
      const resolvedPage = page ? parseInt(page, 10) : defaultData.PAGE;
      const resolvedPerPage = perPage ? parseInt(perPage, 10) : tablePagination.perPage;
      if (page || perPage) {
        setTablePagination((prev) => ({
          ...prev,
          page: resolvedPage,
          perPage: resolvedPerPage,
        }));
      }

      // Trigger fetch with restored filters
      fetchProductList(newFilters, { page: resolvedPage, perPage: resolvedPerPage });
    }
  }, [location.search]); // Update when URL changes (e.g. back/forward navigation)

  // 2. Update URL when filters or pagination change
  useEffect(() => {
    const params = new URLSearchParams();
    const f = filters;

    if (f[0].selectedValue !== "all") params.set("missing", f[0].selectedValue);
    if (
      f[1].selectedValue &&
      f[1].selectedValue.length > 0 &&
      (f[1].selectedValue.length !== 2 ||
        !f[1].selectedValue.includes("ok") ||
        !f[1].selectedValue.includes("quarantine"))
    ) {
      params.set("condition", f[1].selectedValue.join(","));
    }
    if (f[2].selectedValue !== "all") params.set("search", f[2].selectedValue);
    if (f[3].selectedValue !== "all") params.set("equipmentNumber", f[3].selectedValue);
    if (f[4].selectedValue !== "all") params.set("serialNumber", f[4].selectedValue);
    if (f[5].selectedValue !== "all") params.set(Common.LOCATION_KEY, f[5].selectedValue);

    if (tablePagination.page !== defaultData.PAGE) params.set("page", tablePagination.page);
    if (tablePagination.perPage !== defaultData.PER_PAGE_6)
      params.set("perPage", tablePagination.perPage);

    // Update URL without reloading, replacing current entry
    navigate({ search: params.toString() }, { replace: true });
  }, [filters, tablePagination]);

  useEffect(() => {
    const equipment = location?.state?.data;
    if (equipment) {
      // Reset Redux state and set loading to show spinner immediately
      dispatch(resetListState());
      // Inventory Summary drills through on equipment type; the dedicated Type filter is now
      // part of the merged search box, so the type name lands there.
      const tempFilters = filters.map((filter) => {
        if (filter.inputLabel === Common.INVENTORY_SEARCH) {
          return { ...filter, selectedValue: equipment?.equipmentType };
        }
        return filter; // keep others unchanged
      });
      setFilters(tempFilters);
      setShouldUpdateState(!shouldUpdateState);

      // Clear location state to prevent re-triggering (optional but good practice)
      // navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location]);

  const handleInventoryExport = async () => {
    const paramData = createParamData(filters);
    const body = {
      param: new URLSearchParams(paramData).toString(),
      selectedState: {},
    };
    setExportLoading(true);
    const res = await dispatch(exportInventoryExcelDataV2(body));
    setExportLoading(false);
    if (res.payload.status === Common.API_STATUS_200) {
      const url = window.URL.createObjectURL(res.payload.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Invenotry.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      await dispatch(
        openSnackbar({
          message: Constants.INVENTORY_EXCEL_SUCCESS,
          notificationType: Constants.NOTIFICATION_SUCCESS,
        })
      );
    } else {
      await dispatch(
        openSnackbar({
          message: Constants.SOMETHING_WENT_WRONG,
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
    }
  };
  return (
    <DashboardLayout module={defaultData.EQUIPMENT_SCREEN_ID}>
      <DashboardNavbar />
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <PageTitle title={PageTitles?.EQUIPMENT} />
        <MDBox display="flex" flexDirection="row">
          {permission?.create && (
            <CustomButton
              title="Register"
              icon="add_circle_outline"
              background="#191A51"
              color="#ffffff"
              openModal={openInventoryRegisterModalFunc}
            />
          )}

          <Divider
            orientation="vertical"
            sx={{
              backgroundColor: "var(--gray-300, #D0D5DD)",
              height: "auto",
              marginLeft: pxToRem(16),
              marginRight: 0,
            }}
          />

          <BasicButton
            icon={Icons.RELOAD}
            background={Colors.WHITE}
            border
            color={Colors.BLACK}
            action={handleReload}
          />
        </MDBox>
      </MDBox>

      <Divider sx={{ marginTop: 2 }} />

      <MDBox display="flex" justifyContent="space-between">
        <MDBox>
          <MDBox
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "start",
              alignItems: "flex-end",
            }}
            mx={0}
          >
            {/* Search bar */}
            {filters.slice(2, 5).map((item, index) => (
              <ExplicitSearchBar
                freeSolos
                width={item.inputLabel === Common.INVENTORY_SEARCH ? pxToRem(320) : pxToRem(200)}
                key={item.inputLabel.replace(" ", "")}
                options={item?.list.map((val) => val?.title) || []}
                filters={filters}
                label={item?.inputLabel}
                value={
                  item?.selectedValue &&
                  item.selectedValue !== FiltersModuleName.ALL_IN_SMALL_CASE &&
                  item.selectedValue !== ""
                    ? item.selectedValue.charAt(0).toUpperCase() +
                      item.selectedValue.substring(1).toLowerCase()
                    : FiltersModuleName.ALL_WITH_FIRST_LETTER_CAPITAL
                }
                placeholder={item?.inputLabel}
                isLoading={item?.isLoading}
                allowEmptySearch
                onSearchTrigger={(value) => handleExplicitSearch(value, index + 2)}
                handleFilterChange={(e, value) => handleExplicitSearch(value, index + 2)}
              />
            ))}

            <MDBox
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "start",
                alignItems: "flex-end",
              }}
            >
              {filters
                .slice(0, 2)
                .filter((val) => val.inputLabel !== "Search")
                ?.map((val) => {
                  if (val.inputLabel === FiltersModuleName.MISSING) {
                    return (
                      <FilterDropdown
                        key={val.inputLabel}
                        label={val.inputLabel}
                        name={val.inputLabel}
                        value={val?.selectedValue}
                        handleChange={handleFilterType}
                        menu={val.list}
                      />
                    );
                  }
                  if (val.inputLabel === FiltersModuleName.CONDITION) {
                    return (
                      <FormControl variant="standard" size="small">
                        <MultiSelectDropdown
                          key={val.inputLabel}
                          id={val.inputLabel}
                          label={val.inputLabel}
                          name={val.inputLabel}
                          defaultValue={val?.selectedValue}
                          menu={val.list}
                          values={val.selectedValue}
                          valueStyle={{ backgroundColor: Colors.WHITE }}
                          labelStyle={{ fontWeight: 600 }}
                          handleChange={(name, value) =>
                            handleFilterType({ target: { name, value } })
                          }
                          hint={Common.SELECT_CONDITION}
                        />
                      </FormControl>
                    );
                  }
                  return null;
                })}
              <MDBox sx={{ ml: 2 }} width="300px">
                <CustomAutoComplete
                  label={Common.LOCATION_INVENTORY}
                  id={Common.LOCATION_INVENTORY}
                  name={Common.LOCATION_INVENTORY}
                  hint="Select Location"
                  disabled={false}
                  valueStyle={{
                    height: pxToRem(40),
                    padding: pxToRem(1),
                    backgroundColor: Colors.WHITE,
                  }}
                  labelStyle={{
                    fontSize: pxToRem(14),
                    fontWeight: 600,
                    color: Colors.BLACK,
                  }}
                  handleChange={handleFilterType}
                  menu={filters[5]?.list || []}
                  getOptionLabel={(option) => option.title || ""}
                  value={{
                    title:
                      filters[5]?.list?.find(
                        (option) => option[Constants.MONGOOSE_ID] === filters[5]?.selectedValue
                      )?.title || "",
                  }}
                />
              </MDBox>
              <MDBox mr={4}>
                <BasicButton
                  title={exportLoading ? ButtonTitles.EXPORTING : ButtonTitles.EXPORT}
                  icon={Icons.EXPORT}
                  background={Colors.WHITE}
                  border
                  disabled={exportLoading}
                  color={Colors.PRIMARY}
                  action={handleInventoryExport}
                />
              </MDBox>

              <ResetFilterButton handleReset={handleReset} style={{ marginLeft: "1rem" }} />

              {permission?.update && (
                <BasicButton
                  title={!stockShow ? ButtonTitles.ADD_STOCKS : ButtonTitles.CANCEL}
                  icon={!stockShow ? Icons.ACCEPT2 : Icons.CROSS4}
                  background={Colors.WHITE}
                  border
                  borderColor={Colors.PRIMARY}
                  color={Colors.PRIMARY}
                  action={() => setStockShow((prev) => !prev)}
                  style={{ marginTop: pxToRem(45) }}
                />
              )}

              {stockShow && stockData?.stockData?.length > 0 && (
                <BasicButton
                  title={ButtonTitles.EDIT_STOCKS}
                  icon={Icons.EDIT}
                  background={Colors.WHITE}
                  color={Colors.PRIMARY}
                  borderColor={Colors.PRIMARY}
                  border
                  action={() => setOpenStockEditModal(true)}
                />
              )}
            </MDBox>
          </MDBox>
        </MDBox>
      </MDBox>

      <MDBox mt={3} mb={5} key={productList.list}>
        {/* Equipments Table */}
        <InvenotryDataTable
          table={{ columns, rows }}
          isSorted={false}
          entriesPerPage={{ defaultValue: defaultData.PER_PAGE_6 }}
          showTotalEntries={false}
          pagination={{ variant: "gradient", color: "info" }}
          totalRecords={productList.inventoryListTotalRecords}
          loading={productList.loading}
          licenseRequired
          currentPage={tablePagination.page}
          handleTablePagination={handleTablePagination}
          handleCurrentPage={(page) => setTablePagination({ ...tablePagination, page })}
        />
      </MDBox>

      {/* View Equipment Details Drawer */}
      {equipmentAnchor.right && (
        <EquipmentDetailDrawer
          equipmentAnchor={equipmentAnchor}
          equipmentId={equipmentDrawerId}
          closeDrawer={handleCloseEquipmentDetailDrawer}
          handleViewImage={handleImageFullView}
          equipmentKey="equipmentDrawer"
        />
      )}

      <FullScreenImageComponent
        fullScreenImage={fullScreenImage}
        handleCloseFullView={handleCloseFullView}
        src={fullScreenImage}
      />

      {/* Stock Edit Quantity Modal */}
      {openStockEditModal && (
        <BasicModal
          title={ModalContent.UPDATE_STOCKS}
          open={openStockEditModal}
          handleClose={() => setOpenStockEditModal(false)}
          handleAction={handleUpdateStock}
          disabled={stockData.stockData?.length === 0 || disableSubmit}
          actionButton={buttonLoading === false ? ButtonTitles.SAVE : ButtonTitles.LOADING}
          py={0}
          minWidth="65%"
        >
          <MDBox
            sx={{
              minWidth: "100%",
              maxHeight: "400px",
              overflowY: "scroll",
              "::-webkit-scrollbar": {
                width: "5px",
              },
              "::-webkit-scrollbar-thumb": {
                background: "gray",
              },
              scrollbarWidth: "thin",
              scrollbarColor: "gray transparent",
            }}
          >
            <DataTable
              table={{ columns: stockColumns, rows: stockRows }}
              isSorted={false}
              entriesPerPage={{ defaultValue: defaultData.PER_PAGE_4 }}
              showTotalEntries={false}
              pagination={{ variant: "gradient", color: "info" }}
              loading={Constants.FULFILLED}
            />
          </MDBox>
        </BasicModal>
      )}

      {/* Location Modal */}
      <BasicModal
        title="Equipment Location"
        open={equipmentLocation.open}
        handleClose={() => setEquipmentLocation(initialLocation)}
        handleAction={() => setEquipmentLocation(initialLocation)}
        actionButton={ButtonTitles.CANCEL}
        py={0}
        width={pxToRem(500)}
      >
        <Box
          sx={{
            minWidth: equipmentLocation?.data?.length > 5 ? 500 : 350, // Reduced minWidth
            p: 1,
            borderRadius: 1,
            bgcolor: "background.paper",
          }}
        >
          {equipmentLocation?.data?.length === 0 && equipmentLocation?.projectData?.length === 0 ? (
            <Typography
              variant="h6"
              sx={{ textAlign: "center", color: "#3D3E80", fontWeight: 700 }}
            >
              No Data Available
            </Typography>
          ) : (
            <>
              {/* Displaying equipment title and total quantity */}
              {equipmentLocation.loading ? (
                <MDBox
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  {Icons.LOADING2}
                </MDBox>
              ) : (
                <Box sx={{ mb: 1, textAlign: "left" }}>
                  {" "}
                  {/* Reduced margin bottom */}
                  <Box>
                    <Typography
                      variant="body2"
                      fontWeight={600}
                      sx={{
                        color: "#3D3E80",
                        textTransform: "capitalize",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {equipmentLocation.equipmentName}
                    </Typography>
                    <MDBox display="flex" justifyContent="flex-start" alignItems="center">
                      <Typography variant="body2" fontWeight={500} sx={{ color: "#FF914D" }}>
                        Available Quantity:{" "}
                      </Typography>
                      <Typography
                        variant="body2"
                        fontWeight={500}
                        sx={{ color: "#3D3E80", marginLeft: "5px" }}
                      >
                        {equipmentLocation.quantity}{" "}
                      </Typography>
                      <Typography
                        variant="body2"
                        fontWeight={500}
                        sx={{ color: "#FF914D", marginLeft: "35px" }}
                      >
                        Total Quantity:
                      </Typography>
                      <Typography
                        variant="body2"
                        fontWeight={500}
                        sx={{ color: "#3D3E80", marginLeft: "5px" }}
                      >
                        {equipmentLocation.totalQuantity}{" "}
                      </Typography>
                    </MDBox>
                  </Box>
                </Box>
              )}

              {/* Location List */}
              <Grid
                container
                spacing={1}
                sx={{
                  maxHeight: "300px",
                  overflow: "auto",
                  padding: 1,
                  "::-webkit-scrollbar": {
                    width: "5px",
                  },
                  "::-webkit-scrollbar-thumb": {
                    background: Colors.LIGHT_GRAY,
                  },
                  scrollbarWidth: "thin",
                  scrollbarColor: "gray transparent",
                }}
              >
                {/* A warehouse name and a project title are both just names on a card, so the
                    two groups are only labelled when both are on screen at once. */}
                {showLocationSections && (
                  <Grid item xs={12}>
                    <Typography variant="caption" fontWeight={600} sx={{ color: Colors.DARK_GREY }}>
                      In Warehouse
                    </Typography>
                  </Grid>
                )}
                {equipmentLocation?.data?.map((item) => (
                  <Grid
                    item
                    xs={6}
                    sm={12}
                    key={item?.warehouse?.[Constants.MONGOOSE_ID] ?? item?.tracker}
                  >
                    {" "}
                    <Box
                      sx={{
                        p: 1,
                        borderRadius: 1,
                        bgcolor: "#F5F5FA",
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        sx={{ color: "#3D3E80", textTransform: "capitalize" }}
                      >
                        {item?.tracker}
                      </Typography>
                      <MDBox display="flex" alignItems="center">
                        <Typography variant="body2" fontWeight={500} sx={{ color: "#FF914D" }}>
                          Quantity: {item?.quantity}
                        </Typography>
                        {/* One warehouse can hold the equipment at several row/shelf/section
                            slots; the totals above are per warehouse, not per slot. The
                            split itself is on hover, same as the list's Location QR cell. */}
                        {item?.locationCount > 1 && (
                          <Tooltip
                            {...darkTooltipProps}
                            placement="right"
                            title={buildQuantityLines(
                              (item?.locationSlots || []).map((slot) => ({
                                label: slot?.locationQRNumber,
                                quantity: slot?.quantity,
                              }))
                            )}
                          >
                            <Typography
                              variant="caption"
                              sx={{ color: Colors.LIGHT_GRAY3, marginLeft: "8px" }}
                            >
                              across {item.locationCount} locations
                            </Typography>
                          </Tooltip>
                        )}
                      </MDBox>
                    </Box>
                  </Grid>
                ))}

                {/* Dispatched stock: which project it went to and how much. Accounts for the
                    gap between Available Quantity and Total Quantity. */}
                {showLocationSections && (
                  <Grid item xs={12}>
                    <Typography variant="caption" fontWeight={600} sx={{ color: Colors.DARK_GREY }}>
                      On Project
                    </Typography>
                  </Grid>
                )}
                {equipmentLocation?.projectData?.map((item) => (
                  <Grid
                    item
                    xs={6}
                    sm={12}
                    key={item?.project?.[Constants.MONGOOSE_ID] ?? item?.tracker}
                  >
                    <Box
                      sx={{
                        p: 1,
                        borderRadius: 1,
                        bgcolor: "#F5F5FA",
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        sx={{ color: "#3D3E80", textTransform: "capitalize" }}
                      >
                        {item?.tracker}
                        {item?.project?.projectNumber ? ` (${item.project.projectNumber})` : ""}
                      </Typography>
                      <MDBox display="flex" alignItems="center">
                        <Typography variant="body2" fontWeight={500} sx={{ color: "#FF914D" }}>
                          Quantity: {item?.quantity}
                        </Typography>
                        {/* A project can be supplied by more than one order; name the single
                            order outright and put the split on hover when there are several.
                            The hover carries each order's own status, so a card whose orders
                            disagree still tells the whole story. */}
                        {item?.orders?.length > 0 && (
                          <Tooltip
                            {...darkTooltipProps}
                            placement="right"
                            title={buildQuantityLines(
                              item.orders.map((order) => {
                                const status = (order?.statuses || [])
                                  .map(toStatusTitle)
                                  .join(", ");
                                return {
                                  label: status
                                    ? `${order?.orderNumber} · ${status}`
                                    : order?.orderNumber,
                                  quantity: order?.quantity,
                                };
                              })
                            )}
                          >
                            <Typography
                              variant="caption"
                              sx={{ color: Colors.LIGHT_GRAY3, marginLeft: "8px" }}
                            >
                              {item.orders.length > 1
                                ? `across ${item.orders.length} orders`
                                : item.orders[0]?.orderNumber}
                            </Typography>
                          </Tooltip>
                        )}
                        {/* Only when every order on the card agrees. Mixed cards leave this
                            off rather than claim a status the whole line does not share —
                            the hover still lists each order's own. */}
                        {item?.status && (
                          <MDBox ml={1}>
                            <Status title={toStatusTitle(item.status)} />
                          </MDBox>
                        )}
                      </MDBox>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </>
          )}
        </Box>
      </BasicModal>

      {/* Permanent Type Modal */}
      <BasicModal
        title={ModalContent.TYPE_CONVERSION_TITLE}
        open={openPermanentType.open}
        handleClose={() => setOpenPermanentType({ open: false })}
        handleAction={handleTypeConversion}
        actionButton={
          openPermanentType.loading === false ? ButtonTitles.SAVE : ButtonTitles.LOADING
        }
        py={0}
      >
        <MDBox mt={1}>
          <Typography variant="body2" fontWeight={500}>
            Choose equipment type to set as permanent{" "}
          </Typography>
          <CustomAutoComplete
            name={Common.PROJECT_ORDER_EQUIPMENT_TYPE_NAME}
            id={Common.PROJECT_ORDER_EQUIPMENT_TYPE_NAME}
            hint={Common.PROJECT_ORDER_EQUIPMENT_TYPE_LABEL}
            getOptionLabel={(option) => option.title || ""}
            menu={equipmentOptionsList}
            value={{
              title: equipmentOptionsList.find(
                (item) => item[Constants.MONGOOSE_ID] === openPermanentType?.newType
              )?.title,
            }}
            handleChange={(e) =>
              setOpenPermanentType({ ...openPermanentType, newType: e.target.value })
            }
          />
        </MDBox>
      </BasicModal>
      {/* Drawer to Register or Edit Inventory Equipment */}
      <CustomDrawer
        defaultAnchor={openInventoryModal}
        width="80%"
        onDrawerClose={handleInventoryDrawerClose}
      >
        <InventoryRegister
          closeDrawerFunc={handleInventoryDrawerClose}
          equipmentId={equipmentId}
          setShouldUpdateState={setShouldUpdateState}
        />
      </CustomDrawer>
    </DashboardLayout>
  );
}

export default ProductDetails;
